import { API_ROUTES } from "@/constants/routes";
import { type IKARequest } from "@/types/analytics";

export function fireKoalaAnalyticsEvent(data: IKARequest) {
  return fetch(API_ROUTES.KOALA_ANALYTICS, {
    method: "POST",
    body: JSON.stringify(data),
  }).then((response) => response.json());
}
